import { render, staticRenderFns } from "./DivisionView.vue?vue&type=template&id=5a9c7eaa&"
import script from "./DivisionView.vue?vue&type=script&lang=js&"
export * from "./DivisionView.vue?vue&type=script&lang=js&"
import style0 from "./DivisionView.vue?vue&type=style&index=0&id=5a9c7eaa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports